// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/App/Module/Gestion/Component/Fiche/Fiche.scss
// module id = 8271
// module chunks = 2